<template>
  <div>
    <p v-if="selectedTestPatternId === 'Nonsense'" class="textFormatting">
      lkd qickl diealke di cljdlj dljlje dljalj<br/>
      cick lj aieijl cnajd dljajl aljaljl cl dl<br/>
      l dlja elkjalj zoice cicwcl dlj k aljclle<br/>
      cidjlaeic c vmv aljd cvlkjd dk v dl ckcda<br/>
      cl aljdl djciz bnzlkjc kiclka clkda ckash<br/>
      bhaclkj p lzdk eicka ziweic aklz qwesh zo<br/>
      iezldlja d aljd cocl lashcl dizk dla qpcl<br/>
      a dljdlj zlkjcid ewox zljci bichc wicl la<br/>
      claj ljzocb cvloz aid abucbnm dizlk azich<br/>
      ak ucub cuaclj aikcnb aic ibcn aicahc eic<br/>
      dlkz a acibh acoilb aichak chaclh clj ach<br/>
      clkj clja o clia cvual claidh biclah lkch<br/>
      aclk acibhahli blaich ackah cibach cll al<br/>
      lkd qickl diealke di cljdlj dljlje dljalj<br/>
    </p>
    <p v-if="selectedTestPatternId === 'Text'" class="textFormatting">
      After a talking sheepdog gets all the sheep in the pen, he reports back to the farmer:<br/>
      "All 40 accounted for."<br/>
      "But I only have 36 sheep," says the farmer.<br/>
      "I know," says the sheepdog. “But I rounded them up."<br/>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'TestPatternText',
    props: ['selectedTestPatternId'],
  };
</script>

<style scoped>
  .textFormatting {
    font-size: 1.3rem;
    font-family: monospace, monospace;
  }

</style>
